"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faSpinner_1 = require("@fortawesome/pro-solid-svg-icons/faSpinner");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var material_1 = require("@mui/material");
var classnames_1 = __importDefault(require("classnames"));
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var FailSafe_1 = require("components/FailSafe");
var Money_1 = __importDefault(require("components/Money"));
var Text_1 = __importDefault(require("shared/components/Text"));
var backend_1 = require("utils/backend");
var single_1 = require("utils/selectors/single");
var DealType_1 = __importDefault(require("./DealType"));
var Rating_1 = __importDefault(require("./Rating"));
var stylesUnlock_1 = require("./stylesUnlock");
var UnlockInProgress_1 = require("./UnlockInProgress");
var utils_1 = require("./utils");
var DealOffer = function (_a) {
    var _b, _c, _d;
    var deal = _a.deal;
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var serviceId = deal.service.id, dealKey = deal.key;
    var dealUsed = (_c = (_b = company === null || company === void 0 ? void 0 : company.usedDeals) === null || _b === void 0 ? void 0 : _b[serviceId]) === null || _c === void 0 ? void 0 : _c[dealKey];
    var status = deal.dealActivationType === 'Self-served' ? 'link-access' : 'staged';
    var _e = __read((0, backend_1.useCall)('companies-claimDeal', { serviceId: serviceId, dealKey: dealKey, dealUpdate: { status: status } }), 3), takeDeal = _e[0], isL = _e[1], e = _e[2];
    if ((dealUsed === null || dealUsed === void 0 ? void 0 : dealUsed.status) === status) {
        return (0, jsx_runtime_1.jsx)(stylesUnlock_1.Root, { children: (0, jsx_runtime_1.jsx)(UnlockInProgress_1.UnlockInProgress, { deal: deal }) });
    }
    if (dealUsed) {
        return ((0, jsx_runtime_1.jsx)(stylesUnlock_1.Root, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ p: 2, className: stylesUnlock_1.classes.unlockDeal }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, className: (0, classnames_1.default)(stylesUnlock_1.classes.amount, 'success') }, { children: {
                        applied: 'Applied! Waiting for processing...',
                        'self-served': 'You have it!',
                        'application-success': 'You have it!',
                    }[dealUsed.status] })) })) }));
    }
    return ((0, jsx_runtime_1.jsx)(stylesUnlock_1.Root, __assign({ className: stylesUnlock_1.classes.unlockDeal }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ p: 2 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ flexGrow: 1 }, { children: (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, className: stylesUnlock_1.classes.amount }, { children: [deal.type === 'credits' ? 'Value' : 'Save', " ", (0, jsx_runtime_1.jsx)(Money_1.default, { amount: deal.dealValueEstimate }), ' '] })) })), (0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsx)(Rating_1.default, { rating: (0, utils_1.getServiceRating)((_d = deal.service) === null || _d === void 0 ? void 0 : _d.rating) }) })] })), (0, jsx_runtime_1.jsx)(DealType_1.default, { deal: deal, hideValue: true }), (0, jsx_runtime_1.jsx)(FailSafe_1.ErrorBoundary, __assign({ error: e }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ fullWidth: true, disabled: isL, onClick: takeDeal(), sx: { mt: 4 }, endIcon: isL ? (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faSpinner_1.faSpinner, size: "xs", pulse: true }) : null }, { children: "Unlock this deal" })) })), (0, jsx_runtime_1.jsx)(DealTerms, { deal: deal })] })) })));
};
var DealTerms = function (_a) {
    var deal = _a.deal;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var annualWord = deal.isAnnualPlansOnly ? ' annual ' : '';
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var restricted = deal.dealRestrictedPlans;
    var restrictedAnnual = restricted ? annualWord + restricted : "any".concat(annualWord);
    return ((0, jsx_runtime_1.jsx)(stylesUnlock_1.Root, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 1 }, { children: (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: "caption" }, { children: ["*Deal available for new paying clients on ", restrictedAnnual, " ", restricted ? 'plans' : 'plan'] })) })) }));
};
// ToDo: See what's going on here with all this nesting of the component root and the uselessness of the following component
exports.default = (function (_a) {
    var service = _a.service;
    var _b = __read(Object.entries(service.deals)[0], 2), key = _b[0], deal = _b[1];
    return ((0, jsx_runtime_1.jsx)(stylesUnlock_1.Root, { children: (0, jsx_runtime_1.jsx)(DealOffer, { deal: __assign(__assign({}, deal), { key: key, service: service }) }, key) }));
});
